import Vue from 'vue'
import store from '@/store'
import VueXI18n from 'vuex-i18n'

Vue.use(VueXI18n.plugin, store)

const messages = {}
const requireContext = require.context('./messages', true, /.*\.js$/)

requireContext.keys().forEach(file => {
    const lang = file.match(/[a-z]+/)
    messages[lang] = Object.assign({}, messages[lang], requireContext(file).default)
})

Object.keys(messages).forEach(locale => {
    Vue.i18n.add(locale, messages[locale])
})


// WEBPACK FOOTER //
// ./src/i18n/index.js